import { Injectable } from "@angular/core";
import { BaseService } from "../shared/services/base.service";
import { HttpParams } from '@angular/common/http';
import { EventEmitter } from '@angular/core';
@Injectable({
  providedIn: "root",
})
export class CommonService {
  bannerInfo: any;
  _manualChange: boolean = false;
  servicePriorityList: any;
  visibleFields: any =[]
  formService: any = {};
  documentData = new EventEmitter();
  constructor(private baseService: BaseService) { 
  //  this.getPriorityColor();
  }

  getClass(item, field?) {
    //console.log("in get class");
    let class_: string = "";
    if (field != undefined) {
      return this.setclass(field, item, class_);
    } else {
      return class_;
    }
  }
  setclass(field, item, class_) {
    if (item) {
      for (let val of field) {
        if (eval(val.expression)) {
          return (class_ =
            val.class != undefined
              ? val.class
              : val.class_name
                ? val.class_name
                : "");
        }
      }
    }
  }

  getPriorityColor(callback = null) {
    const key = 'facility_master_service_priority_getPriorityColor_list';

    this.baseService.getWithCache(
        key,
        () => {
            let data = {
                "projectionKeys": "id,color,code,fullName,serviceType_code,service_priority_id,color_Id",
                filter: "status_id:active"
            };
            return this.baseService.getData(data, "", "facility_master_service_priority", "facility-management", "GET_ALL");
        }
    ).subscribe({
        next: (res: any) => {
            if (res) {
                this.servicePriorityList = res.data;
            }
            if (callback != null) {
                callback();
            }
        },
        error: (err) => {
            console.error("Failed to fetch priority color:", err);
            if (callback != null) {
                callback();
            }
        }
    });
}

  getText(item, field?) {
    let val = "";
    if (field != undefined) {
      return this.setText(item, field);
    } else {
      return val;
    }
  }

  setText(data, condition) {
    let val = "";
    if (condition != undefined && condition != undefined) {
      let item = data;
      for (let currentCondt of condition) {
        if (eval(currentCondt.expression)) {
          val = eval(currentCondt.format)(item);
          break;
        }
      }
    }
    return val;
  }

  setBanner(bannerObj, val) {
    this.bannerInfo = { bannerObj: bannerObj, val: val };
  }

  setManualChange(manualChange) {
    this._manualChange = manualChange;
  }
  getExtraData(extraData) {
    if (extraData) {
      return extraData.value;
    } else {
      return {};
    }
  }
  checkStrIsAlphaNumeric(str) {
    let mainStr = `ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_!"#$%&'()*+,-./:;<=>?@[\]^_{|}~`;
    if (mainStr.includes(str)) return true;
    else return false;
  }
  getPopOverDetails(question, data_, extraData, selectedItems) {
    if (question.hasOwnProperty("popover")) {
      let str = "";
      let isFlag: boolean = false;
      // if(!this.utilService.isMobile()){
      if ((data_ && data_.length > 0) || extraData.value) {
        let data = this.getExtraData(extraData);
        // data_ && data_[0] && data_[0].mixdata
        //   ? data_[0].mixdata
        //   : this.getExtraData(extraData);
        // data = Object.seal(data);
        if (question && !data.itemFlag) {
          if (data['brandWiseMedication.itemCode'] && question.options && question.options.length > 0) {
            let itemcode = data['brandWiseMedication.itemCode'];
            data = question.options.find((d) => { return d.itemCode == itemcode });
            if (data && data !=undefined && data.composition){
              data['brandWiseMedication.composition'] = data.composition;
            }  
            if (data == undefined && selectedItems && selectedItems[0] && selectedItems[0].mixdata){
              data = this.getExtraData(extraData);
              data['brandWiseMedication.composition'] = selectedItems[0].mixdata.composition ? selectedItems[0].mixdata.composition:'';
              if (selectedItems[0].mixdata.itemFlag){
                data.itemFlag = selectedItems[0].mixdata.itemFlag;
              }
            }
          } else if (data && data.itemCode) {
            let itemcode = data['itemCode'];
            data = question.options ? question.options.find((d) => { return d.itemCode == itemcode }) : null;
          }
          if (data && ((data['brandWiseMedication.composition'] && data['brandWiseMedication.composition'] == "") || !data.itemFlag)){
            if (selectedItems && selectedItems[0] && selectedItems[0].mixdata) {
              data = this.getExtraData(extraData);
              data['brandWiseMedication.composition'] = selectedItems[0].mixdata.composition ? selectedItems[0].mixdata.composition : '';
              if (selectedItems[0].mixdata.itemFlag) {
                data.itemFlag = selectedItems[0].mixdata.itemFlag;
              }
            }
          }
        }
        if (question && data) {
          if (question.flag && data.hasOwnProperty("itemFlag")) {
            let t = [];
            if (data.itemFlag && data.itemFlag.length > 0) {
              for (let o of data.itemFlag) {
                t.push(o.text);
              }
            }
            if (t.length > 0) {
              str += `<div><b>Flags:</b>${t.join(",")}</div>`;
              isFlag = true;
            }
          }
          if (data.hasOwnProperty(question.popover) && data[question.popover]) {
            str += `<div><b>Composition:</b>${data[question.popover]}</div>`;
          } else {
            //data = this.getExtraData(extraData);
            if (data.hasOwnProperty(question.popover) && data[question.popover]) {
              str += `<div><b>Composition:</b>${data[question.popover]}</div>`;
            }
          }
          if (data && !isFlag && data.hasOwnProperty("itemFlag") && data.itemFlag) {
            let t = [];
            if (data.itemFlag.length > 0) {
              for (let o of data.itemFlag) {
                t.push(o.text);
              }
            }
            if (t.length > 0) {
              str += `<div><b>Flags:</b>${t.join(",")}</div>`;
            }
          }
          return str ? str : null;
        }
      }
      // }
    }
  }
  checkBarCodeDependents(config, formService, res) {
    // try {
    this.checkConditionApplicableForBarcode(config, formService, res);
    // } catch (error) {
    //console.error(error);
    // formService.alerts.error("Error occured while reading barcode");
    //}
  }
  checkConditionApplicableForBarcode(config, formService, res) {
    if (config && config.barcode && config.barcode.id) {
      let dependents = config.barcode.id.split(".");
      if (dependents[1] && dependents[0]) {
        formService.compositeFormMapping[dependents[1]].controls[
          dependents[0]
        ].question_component.question.options = res.resource;
        if (res.resource && !res.resource[0].hasOwnProperty(dependents[0])) {
          formService.compositeFormMapping[dependents[1]].controls[
            dependents[0]
          ].setValue(res.resource[0]['itemName']);
          if (res.resource && formService.compositeFormMapping[dependents[1]].controls['itemName']) {
            formService.compositeFormMapping[dependents[1]].controls['itemName'].setValue(res.resource[0]['itemName']);
          }
        } else {
          formService.compositeFormMapping[dependents[1]].controls[
            dependents[0]
          ].setValue(res.resource[0][dependents[0]]); // need to recheck
        }
        formService.compositeFormMapping[dependents[1]].controls[
          dependents[0]
        ].question_component.question.datasource = JSON.parse(
          JSON.stringify(
            formService.compositeFormMapping[dependents[1]].controls[
              dependents[0]
            ].question_component.question.datasource
          )
        );
        //Hard Coaded for inventory-management need to refactor
        if (formService && formService.compositeFormMapping && formService.compositeFormMapping.directReceiveItem) {
          this.formService = formService;
          this.checkOnselectAPiCallReq(formService.compositeFormMapping[dependents[1]].controls[
            dependents[0]
          ].question_component.question, formService, res);
        }
        setTimeout(() => {
          formService.compositeFormMapping[dependents[1]].controls[
            dependents[0]
          ].question_component.updateDependentValue(res.resource[0]);
        });
      } else if (
        dependents[0] &&
        formService.popupForm &&
        config.barcode &&
        config.barcode.isOptical
      ) {
        // For optical only neeed to review code again
        formService.popupForm.controls[
          dependents[0]
        ].question_component.question.options = res.resource;
        setTimeout(() => {
          formService.popupForm.controls["displayName"].setValue(
            res.resource[0]["itemName"]
          );
          formService.popupForm.controls[dependents[0]].setValue(
            res.resource[0]["itemCode"]
          );
          formService.popupForm.controls[
            dependents[0]
          ].question_component.question.datasource = JSON.parse(
            JSON.stringify(
              formService.popupForm.controls[dependents[0]].question_component
                .question.datasource
            )
          );
          formService.popupForm.controls[
            dependents[0]
          ].question_component.updateDependentValue(res.resource[0]);
        }, 1000);
      } else if (
        dependents[0] &&
        formService.form &&
        config.barcode &&
        !config.barcode.isOptical
      ) {
        setTimeout(() => {
          formService.form.controls[dependents[0]].setValue(
            res.resource[0][dependents[0]]
          );
          formService.form.controls[
            dependents[0]
          ].question_component.question.datasource = JSON.parse(
            JSON.stringify(
              formService.form.controls[dependents[0]].question_component
                .question.datasource
            )
          );
          formService.form.controls[
            dependents[0]
          ].question_component.updateDependentValue(res.resource[0]);
        }, 1000);
      }
    }
  }
  initGeolocation(callback) {
    if (navigator.geolocation) {
      // Call getCurrentPosition with success and failure callbacks High precision// GPS accuracy
      //navigator.geolocation.getCurrentPosition(this.success, this.fail);
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position: any) => {
          if (position) {
            let getAddress = { latitude: position.coords.latitude, longitude: position.coords.longitude }
            console.log(getAddress);
            callback(getAddress);
          } else {
            callback({});
          }
        })
      }
    } else {
      console.log("Sorry, your browser does not support geolocation services.");
      callback({});
    }
  }

  // getCountryOnLatLong(obj) {
  //     var d = document;
  //     var s = d.createElement("script");
  //     s.setAttribute("src", "https://cdn.jsdelivr.net/npm/@turf/turf@6/turf.min.js");
  //     (d.body || d.head).appendChild(s);

  // }
  
  /*****************************While reading barcode check on select api req ************************ */
  checkOnselectAPiCallReq(question: any, formService, res) {
    if (question && question.defaultsetting && question.defaultsetting.onSelectApliCallRequirement) {
      let that = this;
      let obj = question.defaultsetting.onSelectApliCallRequirement;
      let filterParams = {
        filter: `itemCode:${res.resource[0].itemCode},supplierId:${formService.form.controls.supplierId.value}`
      }
      this.baseService.getData(filterParams, "", obj.resource, obj.application, obj.query_id).subscribe(
        (res) => {
          if (res.errCode == -1) {
            console.log("Error occured while getting data", res.message);
            //this.loader.hideSpinner();
          } else if (res.errCode == 0) {
            if (that && that.formService && that.formService.compositeFormMapping.directReceiveItem) {
              let controls = that.formService.compositeFormMapping.directReceiveItem.controls.itemName.question_component.question.defaultsetting.onSelectApliCallRequirement.onResponseFillControls.split(',');
              let response = res.resource[0];
              for (let cn of controls) {
                that.formService.compositeFormMapping.directReceiveItem.controls[cn].setValue(response[cn]);
              }
              that.formService.compositeFormMapping.directReceiveItem.updateValueAndValidity();
            }

          }
        }, (err) => {
          console.log("Error occured while getting data", err);
        });
    }
  }

  readQueryParams(key) {
    let url = window.location.href
    let params = new HttpParams({ fromString: url.split("?")[1] })
    return params.get(key);
  }

  documentPopup(event) {
    this.documentData.emit(event);
  }

  setMetaElements() {
    // return true;
    let r = document.getElementsByName('id')[0].getAttribute('content');
    let l = localStorage.getItem('meta-id');
    if (l == null || l.length == 0) {
      localStorage.setItem('meta-id', JSON.stringify({ 'key': [r] }));
      return true;
    } else {
      let re = JSON.parse(l);
      // localStorage.removeItem('meta-id');
      let arr = re['key'];
      if (arr.includes(r)) {
        const dialogRef = this.baseService.modalService.alert('Alert', 'This Tab is already open', 'lg', true, true);
        dialogRef.subscribe(result => {
          if(result == false){
            this.DestroyMetaElements();
          }else{
            arr = arr.concat([r]);
            localStorage.setItem('meta-id', JSON.stringify({ 'key': arr }));
          }
          window.location.href = window.location.origin;
          return false;
        }, () => { });
      } else {
        arr = arr.concat([r]);
        localStorage.setItem('meta-id', JSON.stringify({ 'key': arr }));
        return true;
      }
    }
  }

  DestroyMetaElements() {
    let r = document.getElementsByName('id')[0].getAttribute('content');
    let l = localStorage.getItem('meta-id');
    if (l != null) {
      let array = JSON.parse(l)['key'];
      const index = array.indexOf(r);
      if (index > -1) { // only splice array when item is found
        array.splice(index, 1); // 2nd parameter means remove one item only
      }
      if (array.length > 0) {
        // localStorage.removeItem('meta-id');
        localStorage.setItem('meta-id', JSON.stringify({ 'key': array }));
      } else {
        localStorage.removeItem('meta-id');
      }
    }
  }
}